import Vue from "vue";
import Vuetify from "vuetify";
import "vuetify/dist/vuetify.min.css";

Vue.use(Vuetify);

const opts = {
  theme: {
    themes: {
      light: {
        primary: "#002363",
        secondary: "#F7CE00"
      }
    }
  }
};

export default new Vuetify(opts);
